// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const drawerWidthCollapsed = 72; // Collapsed sidebar width
export const appDrawerWidth = 320;
export const HEADER_HEIGHT = 74; // Header/AppBar height in pixels
